import frenchMessages from 'ra-language-french';

export default {
    ...frenchMessages,
    keyboard_arrow_left: "<",
    keyboard_arrow_right: ">",
    no_driver_avail: 'Aucun chauffeur disponbible pour assigner la commande',
    price_rent_exist_already: "La configuration du prix de cette gamme et la durée existe déjà",
    price_exist_already: "La configuration du prix de ce type de véhicule, cette gamme et le type de commande existe déjà",
    promo_code_exist_already: 'Le code remise existe déjà',
    format_date:'DD/MM/YYYY',
    format_date_time:'DD/MM/YYYY HH:mm:ss',
    dashboard: {
        drivers: {
            list: 'Livreurs',
            online: 'Livreurs en-ligne',
        },
        clients: 'Clients',
        clients_pro: 'Clients pros',
        driver_companies: 'Société de livreurs',
        orders: {
            running: "Commandes en cours",
            unassigned: "Réservations à assigner",
        },
    },
   

    name: 'Nom',
    first_name: 'Prénom',
    last_name: 'Nom',
    civility: 'Civilité',
    max_size: 'Taille maximale:',
    menu:{
        accounts: "Comptes",
        vehicles: "Véhicules",
        orders: "Commandes",
        prices: "Prix",
        services: "Services",
        settings: "Paramètres",
        reporting: "Reporting",
        configuration: "Configurations",
    },
    // pos: {
    //     search: 'Rechercher',
    //     configuration: 'Configuration',
    //     language: 'Langue',
    //     theme: {
    //         name: 'Theme',
    //         light: 'Clair',
    //         dark: 'Obscur',
    //     },
    //     dashboard: {
    //         monthly_revenue: 'CA à 30 jours',
    //         new_orders: 'Nouvelles commandes',
    //         pending_reviews: 'Commentaires à modérer',
    //         new_customers: 'Nouveaux clients',
    //         pending_orders: 'Commandes à traiter',
    //         order: {
    //             items:
    //                 'par %{customer_name}, un poster |||| par %{customer_name}, %{nb_items} posters',
    //         },
    //         welcome: {
    //             title: 'Bienvenue sur la démo de react-admin',
    //             subtitle:
    //                 "Ceci est le back-office d'un magasin de posters imaginaire. N'hésitez pas à explorer et à modifier les données. La démo s'exécute en local dans votre navigateur, et se remet à zéro chaque fois que vous rechargez la page.",
    //             aor_button: 'Site web de react-admin',
    //             demo_button: 'Code source de cette démo',
    //         },
    //     },
    //     menu: {
    //         sales: 'Ventes',
    //         catalog: 'Catalogue',
    //         customers: 'Clients',
    //     },
    // },

    
    
    resources: {
        region:{
            name: 'Wilayas',
            list: 'Wilayas',
            create: 'Créer une wilaya',
            show: 'Wilaya',
            edit: 'Editer wilaya',
        },

        rate_system:{
            name: 'Avis',
            list: 'Avis',
            
        },
           gain:{
            name: 'Gains à payer',
            list: 'Gains à payer',
            
        },

        cancel_category:{
            name: "Motif d'annulation",
            list: "Motifs d'annulation",
            create: "Créer un motif d'annulation",
            show: "Motif d'annulation",
            edit: "Éditer motif d'annulation",
        },

        promo_code:{
            name: 'Codes de réduction',
            list: 'Codes de réduction',
            create: 'Créer un code de réduction',
            show: 'Code de réduction',
            edit: 'Éditer code de réduction',
        },

        notice:{
            name: 'Messages',
            list: 'Messages',
            create: 'Créer un message',
            show: 'Message',
            edit: 'Editer message',
        },

        email_template:{
            name: "Templates d\'email",
            list: "Templates d\'email",
            create: "Créer un template d'\email",
            show: "Template d\'email",
            edit: "Editer template d\'email",
        },

        sms_template:{
            name: "Templates de SMS",
            list: "Templates de SMS",
            create: "Créer un template de SMS",
            show: "Template de SMS",
            edit: "Editer template de SMS",
        },

        driver:{
            name: 'Livreurs',
            list: 'Livreurs',
            create: 'Créer un livreur',
            show: 'Livreur',
            edit: 'Éditer le livreur',
        },

        driver_company:{
            name: 'Sociétés de livraison',
            list: 'Sociétés de livraison',
            create: 'Créer une société de livraison',
            show: 'Société de livraison',
            edit: 'Éditer société de livraison',
        },

        driver_deleted:{
            name: 'Livreurs supprimés',
            list: 'Livreurs supprimés',
            show: 'Livreurs supprimé',
        },

        driver_company_deleted:{
            name: 'Sociétés de chauffeur supprimées',
            list: 'Sociétés de chauffeur supprimées',
            show: 'Société de chauffeur supprimée',
        },

        client:{
            name: 'Clients',
            list: 'Clients',
            create: 'Créer un client',
            show: 'Client',
            edit: 'Éditer un client',
        },

        client_product:{
            name: 'Produits différés',
            list: 'Produits différés',
            // create: 'Créer un client',
            // show: 'Client',
            // edit: 'Éditer un client',
        },

        turnover:{
            name: "Chiffres",
            list: "Chiffres",
            // create: 'Créer un client',
            // show: 'Client',
            // edit: 'Éditer un client',
        },

        client_pro:{
            name: 'Clients professionnels',
            list: 'Clients professionnels',
            create: 'Créer un client professionel',
            show: 'Client professionel',
            edit: 'Éditer un client professionel',
        },

        client_deleted:{
            name: 'Clients supprimés',
            list: 'Clients supprimés',
            show: 'Client supprimé',
        },

        location:{
            name: 'Lieux',
            list: 'Lieux',
            create: 'Créer un lieu',
            show: 'Lieu',
            edit: 'Éditer le lieu',
        },

        option:{
            name: 'Options',
            list: 'Options',
            create: 'Créer une option',
            show: 'Option',
            edit: 'Éditer option',
        },

        price:{
            name: 'Prix',
            list: 'Prix',
            create: 'Créer un prix',
            show: 'Prix',
            edit: 'Éditer prix',
        },

        product:{
            name: 'Produits',
            list: 'Produits',
            create: 'Créer un produit',
            show: 'Produit',
            edit: 'Éditer produit',
        },

        price_base:{
            name: 'Prix de base',
            list: 'Prix de base',
            create: 'Créer un prix de base',
            show: 'Prix de base',
            edit: 'Éditer prix de base',
        },

        price_rent:{
            name: 'Location du chauffeur',
            list: 'Location du chauffeur',
            create: 'Créer un prix de location',
            show: 'Location du chauffeur',
            edit: 'Éditer location du chauffeur',
        },

        price_time:{
            name: "Majorations",
            list: "Majorations",
            create: "Créer une majoration/remise d'horaire",
            show: "Majoration/remise d'horaire",
            edit: "Éditer majoration/remise d'horaire",
        },

        price_route:{
            name: "Forfaits route",
            list: "Forfaits route",
            create: "Créer un forfait route",
            show: "Forfait route",
            edit: "Éditer forfait route",
        },

        price_distance:{
            name: "Forfaits distance",
            list: "Forfaits distance",
            create: "Créer un forfait distance",
            show: "Forfait distance",
            edit: "Éditer forfait distance",
        },

        order_running:{
            name: ' Commandes en cours',
            list: 'Commandes en cours',
            show: 'Commande',
            
        },

        order_finished:{
            name: ' Commandes terminées',
            list: 'Commandes terminées',
            show: 'Commande',
        },

        order_unassigned:{
            name: 'Commandes en attente',
            list: 'Commandes en attente',
            show: 'Commande en attente',
            
        },

        vehicle_type:{
            name: 'Gammes',
            list: 'Gammes',
            create: 'Créer une gamme',
            show: 'Gamme',
            edit: 'Éditer une gamme',
        },

        vehicle_model:{
            name: 'Modèles',
            list: 'Modèles de véhiule',
            create: 'Créer un modèle de véhicule',
            show: 'Modèle de véhicule',
            edit: 'Éditer un modèle de véhicule',
        },

        vehicle_brand:{
            name: 'Marques',
            list: 'Marques de véhicule',
            create: 'Créer une marque de véhicule',
            show: 'Marque de véhicule',
            edit: 'Éditer une marque de véhicule',
        },
        vehicle:{
            name: 'Véhicules',
            list: 'Véhicules',
            create: 'Créer un véhicle',
            show: 'Véhicle',
            edit: 'Éditer véhicle',
        },
        
        // customers: {
        //     name: 'Client |||| Clients',
        //     fields: {
        //         address: 'Rue',
        //         birthday: 'Anniversaire',
        //         city: 'Ville',
        //         commands: 'Commandes',
        //         first_name: 'Prénom',
        //         first_seen: 'Première visite',
        //         groups: 'Segments',
        //         has_newsletter: 'Abonné à la newsletter',
        //         has_ordered: 'A commandé',
        //         last_name: 'Nom',
        //         last_seen: 'Vu le',
        //         last_seen_gte: 'Vu depuis',
        //         latest_purchase: 'Dernier achat',
        //         name: 'Nom',
        //         total_spent: 'Dépenses',
        //         zipcode: 'Code postal',
        //         password: 'Mot de passe',
        //         confirm_password: 'Confirmez le mot de passe',
        //     },
        //     fieldGroups: {
        //         identity: 'Identité',
        //         address: 'Adresse',
        //         stats: 'Statistiques',
        //         history: 'Historique',
        //         password: 'Mot de passe',
        //         change_password: 'Changer le mot de passe',
        //     },
        //     page: {
        //         delete: 'Supprimer le client',
        //     },
        //     errors: {
        //         password_mismatch:
        //             'La confirmation du mot de passe est différent du mot de passe.',
        //     },
        // },
        // commands: {
        //     name: 'Commande |||| Commandes',
        //     amount: '1 commande |||| %{smart_count} commandes',
        //     title: 'Commande n°%{reference}',
        //     fields: {
        //         basket: {
        //             delivery: 'Frais de livraison',
        //             reference: 'Référence',
        //             quantity: 'Quantité',
        //             sum: 'Sous-total',
        //             tax_rate: 'TVA',
        //             total: 'Total',
        //             unit_price: 'P.U.',
        //         },
        //         customer_id: 'Client',
        //         date_gte: 'Emises depuis',
        //         date_lte: 'Emises avant',
        //         nb_items: 'Nb articles',
        //         reference: 'Référence',
        //         returned: 'Annulée',
        //         status: 'Etat',
        //         total_gte: 'Montant minimum',
        //     },
        // },
        // invoices: {
        //     name: 'Facture |||| Factures',
        //     fields: {
        //         id: 'Numéro',
        //         date: 'Date de facture',
        //         customer_id: 'Client',
        //         command_id: 'Commande',
        //         date_gte: 'Emises depuis',
        //         date_lte: 'Emises avant',
        //         address: 'Adresse',
        //         total_ex_taxes: 'Montant HT',
        //         delivery_fees: 'Frais de livraison',
        //         taxes: 'TVA',
        //     },
        // },
        // products: {
        //     name: 'Poster |||| Posters',
        //     fields: {
        //         category_id: 'Catégorie',
        //         height_gte: 'Hauteur mini',
        //         height_lte: 'Hauteur maxi',
        //         height: 'Hauteur',
        //         image: 'Photo',
        //         price: 'Prix',
        //         reference: 'Référence',
        //         stock_lte: 'Stock faible',
        //         stock: 'Stock',
        //         thumbnail: 'Aperçu',
        //         width_gte: 'Largeur mini',
        //         width_lte: 'Margeur maxi',
        //         width: 'Largeur',
        //     },
        //     tabs: {
        //         image: 'Image',
        //         details: 'Détails',
        //         description: 'Description',
        //         reviews: 'Commentaires',
        //     },
        // },
        // categories: {
        //     name: 'Catégorie |||| Catégories',
        //     fields: {
        //         name: 'Nom',
        //         products: 'Produits',
        //     },
        // },
        // reviews: {
        //     name: 'Commentaire |||| Commentaires',
        //     amount: '1 commentaire |||| %{smart_count} commentaires',
        //     relative_to_poster: 'Commentaire sur',
        //     detail: 'Détail du commentaire',
        //     fields: {
        //         customer_id: 'Client',
        //         command_id: 'Commande',
        //         product_id: 'Produit',
        //         date_gte: 'Publié depuis',
        //         date_lte: 'Publié avant',
        //         date: 'Date',
        //         comment: 'Texte',
        //         status: 'Statut',
        //         rating: 'Classement',
        //     },
        //     action: {
        //         accept: 'Accepter',
        //         reject: 'Rejeter',
        //     },
        //     notification: {
        //         approved_success: 'Commentaire approuvé',
        //         approved_error: 'Erreur: Commentaire non approuvé',
        //         rejected_success: 'Commentaire rejeté',
        //         rejected_error: 'Erreur: Commentaire non rejeté',
        //     },
        // },
        // segments: {
        //     name: 'Segments',
        //     fields: {
        //         customers: 'Clients',
        //         name: 'Nom',
        //     },
        //     data: {
        //         compulsive: 'Compulsif',
        //         collector: 'Collectionneur',
        //         ordered_once: 'A commandé',
        //         regular: 'Régulier',
        //         returns: 'A renvoyé',
        //         reviewer: 'Commentateur',
        //     },
        // },
    },
};
